(function(){
  'use strict';
  if(window.__SickHausHeaderBagWindow)return;
  window.__SickHausHeaderBagWindow=true;

  function ready(callback){
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',callback,{once:true});
    else callback();
  }

  function number(value,fallback){
    var parsed=Number(value);
    return Number.isFinite(parsed)?parsed:(fallback||0);
  }

  function rootPath(){
    return window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/';
  }

  ready(function(){
    var root=document.querySelector('[data-essential-cart]');
    if(!root)return;

    var title=root.querySelector('[data-essential-confirmation-title]');
    var messageCard=root.querySelector('[data-essential-confirmation-message-card]');
    var messageKicker=root.querySelector('[data-essential-confirmation-kicker]');
    var messageHeading=root.querySelector('[data-essential-confirmation-heading]');
    var messageSupport=root.querySelector('[data-essential-confirmation-support]');
    var delivery=root.querySelector('[data-essential-confirmation-delivery]');
    var progress=root.querySelector('[data-essential-confirmation-progress]');
    var productRow=root.querySelector('[data-essential-confirmation-product]');
    var productLink=root.querySelector('[data-essential-confirmation-product-link]');
    var productImage=root.querySelector('[data-essential-confirmation-image]');
    var productTitle=root.querySelector('[data-essential-confirmation-product-title]');
    var productVariant=root.querySelector('[data-essential-confirmation-variant]');
    var productPrice=root.querySelector('[data-essential-confirmation-price]');
    var checkoutLink=root.querySelector('[data-essential-view-bag]');
    var announcer=root.querySelector('[data-essential-announcer]');
    var threshold=number(root.dataset.threshold,0);
    var lowStockThreshold=Math.max(1,number(root.dataset.lowStockThreshold,5));
    var currency=root.dataset.currencyCode||'GBP';
    var deliveryTerm=root.dataset.deliveryTerm||'delivery';
    var closeTimer=null;
    var isOpen=false;
    var productCache={};
    var renderSequence=0;

    function setPrivateHoldMessage(kicker,heading,support){
      if(messageKicker)messageKicker.textContent=kicker||'In demand';
      if(messageHeading)messageHeading.textContent=heading||'Your selection is ready for checkout.';
      if(messageSupport)messageSupport.textContent=support||'Availability can change while items remain in your bag.';
    }

    function track(eventName,data){
      var detail=Object.assign({
        event:eventName,
        cart_surface:'header_confirmation',
        device_class:window.innerWidth<=768?'mobile':'desktop',
        market:root.dataset.countryCode||''
      },data||{});
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push(detail);
      if(typeof window.clarity==='function'){
        try{window.clarity('event',eventName);}catch(error){/* no-op */}
      }
    }

    function money(cents){
      if(window.theme&&theme.Currency&&typeof theme.Currency.formatMoney==='function'){
        return theme.Currency.formatMoney(cents,theme.settings.moneyFormat);
      }
      try{
        return new Intl.NumberFormat(document.documentElement.lang||'en-GB',{
          style:'currency',
          currency:currency
        }).format(number(cents,0)/100);
      }catch(error){
        return (number(cents,0)/100).toFixed(2);
      }
    }

    function fetchCart(){
      return fetch(root.dataset.cartJsonUrl||rootPath()+'cart.js',{
        credentials:'same-origin',
        cache:'no-store',
        headers:{Accept:'application/json'}
      }).then(function(response){
        if(!response.ok)throw new Error('Unable to load bag');
        return response.json();
      });
    }

    function updateHeaderCount(count){
      document.querySelectorAll('.cart-link__bubble-num').forEach(function(node){node.textContent=String(count);});
      document.querySelectorAll('.cart-link__bubble').forEach(function(node){node.classList.toggle('cart-link__bubble--visible',count>0);});
    }

    function payloadItems(detail){
      var items=[];
      var product=detail&&detail.product;
      if(product&&Array.isArray(product.items))items=items.concat(product.items);
      else if(product&&typeof product==='object')items.push(product);
      if(detail&&Array.isArray(detail.items))items=items.concat(detail.items);
      if(detail&&detail.variant&&typeof detail.variant==='object')items.push(detail.variant);
      return items;
    }

    function addedCount(detail){
      var product=detail&&detail.product;
      if(product&&Array.isArray(product.items)&&product.items.length){
        return product.items.reduce(function(sum,item){return sum+Math.max(1,number(item&&item.quantity,1));},0);
      }
      if(detail&&Array.isArray(detail.items)&&detail.items.length){
        return detail.items.reduce(function(sum,item){return sum+Math.max(1,number(item&&item.quantity,1));},0);
      }

      var addButton=detail&&detail.addToCartBtn;
      var form=addButton&&addButton.closest?addButton.closest('form'):null;
      var quantityInput=form&&form.querySelector?form.querySelector('[name="quantity"]'):null;
      if(quantityInput&&quantityInput.value!=''){
        return Math.max(1,number(quantityInput.value,1));
      }
      if(detail&&detail.quantity!=null){
        return Math.max(1,number(detail.quantity,1));
      }

      /* Shopify cart/add.js returns the line item's new total quantity when the
         same variant already exists. That is not the quantity just added. */
      return 1;
    }

    function itemId(item){
      if(!item)return '';
      return String(item.variant_id||item.id||'');
    }

    function selectAddedItem(detail,cart){
      var payload=payloadItems(detail);
      var wantedIds=payload.map(itemId).filter(Boolean);
      var cartItems=cart&&Array.isArray(cart.items)?cart.items:[];
      var match=null;

      if(wantedIds.length){
        match=cartItems.find(function(item){return wantedIds.indexOf(itemId(item))!==-1;})||null;
      }
      if(!match&&detail&&detail.variant&&detail.variant.id){
        match=cartItems.find(function(item){return String(itemId(item))===String(detail.variant.id);})||null;
      }
      if(!match&&payload.length&&payload[0].product_id){
        match=cartItems.find(function(item){return String(item.product_id||'')===String(payload[0].product_id);})||null;
      }
      return match||cartItems[0]||payload[0]||null;
    }

    function imageUrl(item){
      if(!item)return '';
      if(typeof item.image==='string')return item.image;
      if(item.image&&typeof item.image==='object')return item.image.url||item.image.src||'';
      if(typeof item.featured_image==='string')return item.featured_image;
      if(item.featured_image&&typeof item.featured_image==='object')return item.featured_image.url||item.featured_image.src||'';
      if(item.featured_media&&item.featured_media.preview_image){
        return item.featured_media.preview_image.src||item.featured_media.preview_image.url||'';
      }
      return '';
    }

    function variantText(item){
      if(!item)return '';
      var value=item.variant_title||item.public_title||'';
      if(!value&&Array.isArray(item.options_with_values)){
        value=item.options_with_values.map(function(option){return option.value;}).filter(Boolean).join(' · ');
      }
      if(!value&&Array.isArray(item.options))value=item.options.filter(Boolean).join(' · ');
      return String(value||'').replace(/^Default Title$/i,'');
    }

    function productName(item){
      if(!item)return '';
      return item.product_title||(item.product&&item.product.title)||item.title||item.name||'';
    }

    function itemPrice(item){
      if(!item)return 0;
      if(item.final_price!=null)return number(item.final_price,0);
      if(item.discounted_price!=null)return number(item.discounted_price,0);
      return number(item.price,0);
    }

    function productHandle(item){
      if(!item)return '';
      if(item.handle)return item.handle;
      if(item.product_handle)return item.product_handle;
      var url=String(item.url||'');
      var match=url.match(/\/products\/([^/?#]+)/i);
      return match?match[1]:'';
    }

    function inventoryRecord(productId,variantId){
      if(!window.inventories)return null;
      var productInventory=window.inventories[String(productId)]||window.inventories[productId];
      if(!productInventory)return null;
      return productInventory[String(variantId)]||productInventory[variantId]||null;
    }

    function lowStockFromVariant(variant,quantity){
      if(!variant)return null;
      var policy=String(variant.inventory_policy||variant.policy||'').toLowerCase();
      var management=variant.inventory_management;
      if(management==null&&variant.quantity!=null)management='shopify';
      if(!management||policy==='continue')return false;
      var raw=variant.inventory_quantity;
      if(raw==null)raw=variant.quantity;
      if(raw==null||raw==='')return null;
      var available=number(raw,0);
      if(available<=0)return false;
      return available-Math.max(1,number(quantity,1))<=lowStockThreshold;
    }

    function resolveLowStock(detail,item){
      var quantity=Math.max(1,number(item&&item.quantity,1));
      var variants=[];
      if(detail&&detail.variant)variants.push(detail.variant);
      payloadItems(detail).forEach(function(entry){variants.push(entry);});
      var known=inventoryRecord(item&&item.product_id,itemId(item));
      if(known)variants.push(known);

      for(var index=0;index<variants.length;index+=1){
        var state=lowStockFromVariant(variants[index],quantity);
        if(state!==null)return Promise.resolve(state);
      }

      var handle=productHandle(item);
      if(!handle)return Promise.resolve(false);
      if(productCache[handle])return productCache[handle].then(function(product){
        var variant=(product.variants||[]).find(function(entry){return String(entry.id)===itemId(item);});
        return lowStockFromVariant(variant,quantity)===true;
      });

      productCache[handle]=fetch(rootPath()+'products/'+encodeURIComponent(handle)+'.js',{
        credentials:'same-origin',
        cache:'force-cache',
        headers:{Accept:'application/json'}
      }).then(function(response){
        if(!response.ok)throw new Error('Product unavailable');
        return response.json();
      }).catch(function(){return {variants:[]};});

      return productCache[handle].then(function(product){
        var variant=(product.variants||[]).find(function(entry){return String(entry.id)===itemId(item);});
        return lowStockFromVariant(variant,quantity)===true;
      });
    }

    function renderProduct(item){
      if(!item||!productRow){
        if(productRow)productRow.hidden=true;
        return;
      }

      var name=productName(item);
      var variant=variantText(item);
      var image=imageUrl(item);
      var url=item.url||root.dataset.cartPageUrl||'/cart';

      if(!name){
        productRow.hidden=true;
        return;
      }

      productRow.hidden=false;
      if(productTitle){productTitle.textContent=name;productTitle.href=url;}
      if(productVariant)productVariant.textContent=variant;
      if(productPrice)productPrice.textContent=money(itemPrice(item));
      if(productLink)productLink.href=url;

      if(productImage){
        if(image){
          productImage.src=image;
          productImage.alt=name+(variant?' — '+variant:'');
          productImage.closest('.sh-header-bag-window__media').hidden=false;
        }else{
          productImage.removeAttribute('src');
          productImage.alt='';
          productImage.closest('.sh-header-bag-window__media').hidden=true;
        }
      }
    }

    function positionMobile(){
      if(window.innerWidth>768){
        root.style.removeProperty('--sh-bag-window-top');
        return;
      }
      var header=document.querySelector('#SiteHeader')||document.querySelector('.site-header');
      var rect=header?header.getBoundingClientRect():null;
      var top=rect?Math.max(12,Math.round(rect.bottom+8)):112;
      root.style.setProperty('--sh-bag-window-top',top+'px');
    }

    function render(cart,detail){
      var count=addedCount(detail);
      var remaining=Math.max(0,threshold-number(cart.total_price,0));
      var percentage=threshold>0?Math.min(100,Math.max(0,number(cart.total_price,0)/threshold*100)):100;
      var addedItem=selectAddedItem(detail,cart);
      var currentRender=++renderSequence;
      var isFirstCartAdd=number(cart.item_count,0)>0&&number(cart.item_count,0)<=count;

      title.textContent=count===1?'1 item added to your basket':count+' items added to your basket';
      renderProduct(addedItem);
      if(messageCard)messageCard.hidden=!isFirstCartAdd;
      root.classList.toggle('has-private-hold',isFirstCartAdd);
      root.classList.toggle('is-conversion-urgent',isFirstCartAdd);
      root.classList.remove('is-low-stock');

      if(isFirstCartAdd){
        setPrivateHoldMessage(
          'In demand',
          'Your selection is ready for checkout.',
          'Availability can change while items remain in your bag.'
        );

        resolveLowStock(detail,addedItem).then(function(isLowStock){
          if(!isOpen||currentRender!==renderSequence||!isFirstCartAdd)return;
          root.classList.toggle('is-low-stock',isLowStock);
          if(isLowStock){
            setPrivateHoldMessage(
              'Moving fast',
              'Your selection is ready for checkout.',
              'Availability is limited for this item.'
            );
            track('cart_add_confirmation_low_stock',{variant_id:itemId(addedItem),product_title:productName(addedItem),product_handle:productHandle(addedItem)});
          }
        });
      }

      if(delivery){
        if(cart.item_count===0)delivery.textContent='';
        else if(remaining===0)delivery.textContent='Free '+deliveryTerm+' unlocked.';
        else delivery.textContent=money(remaining)+' from free '+deliveryTerm+'.';
      }

      if(progress)progress.style.width=percentage+'%';
      root.classList.remove('is-delivery-complete');
      if(remaining===0&&cart.item_count>0){
        void root.offsetWidth;
        root.classList.add('is-delivery-complete');
      }

      updateHeaderCount(number(cart.item_count,0));
      return addedItem;
    }

    function open(detail){
      fetchCart().then(function(cart){
        var addedItem=render(cart,detail||{});
        positionMobile();
        root.hidden=false;
        root.setAttribute('aria-hidden','false');
        root.classList.remove('is-opening');
        void root.offsetWidth;
        root.classList.add('is-opening');
        isOpen=true;
        announcer.textContent=title.textContent;
        clearTimeout(closeTimer);
        closeTimer=setTimeout(close,9000);
        var eventData={
          cart_item_count:Number(cart.item_count||0),
          cart_value_cents:Number(cart.total_price||0),
          variant_id:itemId(addedItem),
          product_title:productName(addedItem),
          product_handle:productHandle(addedItem),
          private_hold_shown:Boolean(number(cart.item_count,0)>0&&number(cart.item_count,0)<=addedCount(detail||{}))
        };
        track('cart_add_confirmation_view',eventData);
        document.dispatchEvent(new CustomEvent('sickhaus:bag-confirmation-open',{detail:{cart:cart,item:addedItem}}));
      }).catch(function(){
        window.location.assign(root.dataset.cartPageUrl||'/cart');
      });
    }

    function close(){
      if(!isOpen)return;
      clearTimeout(closeTimer);
      root.setAttribute('aria-hidden','true');
      root.hidden=true;
      root.classList.remove('is-opening');
      isOpen=false;
    }

    if(checkoutLink)checkoutLink.addEventListener('click',function(){
      track('cart_add_confirmation_checkout');
    });

    document.addEventListener('click',function(event){
      if(!isOpen)return;
      if(root.contains(event.target))return;
      close();
    });

    document.addEventListener('keydown',function(event){
      if(isOpen&&event.key==='Escape'){
        event.preventDefault();
        close();
      }
    });

    window.addEventListener('resize',positionMobile,{passive:true});
    window.addEventListener('orientationchange',positionMobile,{passive:true});
    window.addEventListener('scroll',positionMobile,{passive:true});
    if(window.visualViewport){
      window.visualViewport.addEventListener('resize',positionMobile,{passive:true});
      window.visualViewport.addEventListener('scroll',positionMobile,{passive:true});
    }
    document.addEventListener('ajaxProduct:added',function(event){open(event.detail||{});});
    document.addEventListener('cart:updated',function(event){
      var cart=event.detail&&event.detail.cart;
      if(cart)updateHeaderCount(number(cart.item_count,0));
    });
    document.addEventListener('cart:build',function(){
      fetchCart().then(function(cart){updateHeaderCount(number(cart.item_count,0));}).catch(function(){});
    });
    window.addEventListener('pageshow',function(){
      fetchCart().then(function(cart){updateHeaderCount(number(cart.item_count,0));}).catch(function(){});
    });

    fetchCart().then(function(cart){updateHeaderCount(number(cart.item_count,0));}).catch(function(){});
  });
})();
